import type { ChannelCloseoutOperationItem } from '@/shared/api';
import { cn } from '@/shared/lib/cn';
import { closeoutErrorText, operationStatusLabel } from './channelCloseoutPresentation';

/** Für die Fehlersuche, nicht für den Alltag — deshalb eingeklappt. */
export function ChannelCloseoutOperations({
  operations,
}: {
  operations: ChannelCloseoutOperationItem[];
}) {
  if (operations.length === 0) return null;
  return (
    <details className="border-hairline border-t pt-4">
      <summary className="text-ink cursor-pointer text-sm font-semibold">
        Übertragungsverlauf ({operations.length})
      </summary>
      <ul className="mt-2 space-y-2">
        {operations.map((operation) => (
          <li key={operation.id} className="text-ink-soft text-xs">
            <div className="flex justify-between gap-3">
              <span>
                {operation.type === 'Create'
                  ? 'Schließen'
                  : operation.type === 'Delete'
                    ? 'Aufheben'
                    : 'Ändern'}{' '}
                · {operationStatusLabel(operation.status)}
              </span>
              <span className="text-ink-faint shrink-0">
                {operation.attempts} {operation.attempts === 1 ? 'Versuch' : 'Versuche'}
              </span>
            </div>
            {operation.lastErrorCode && (
              // Rot nur für Endgültiges; ein Wartegrund löst sich meist von selbst.
              <p
                className={cn(
                  'mt-0.5',
                  operation.status === 'Failed' ? 'text-sealwax' : 'text-ink-soft',
                )}
              >
                {closeoutErrorText(operation.lastErrorCode, operation.status === 'Failed')}
              </p>
            )}
          </li>
        ))}
      </ul>
    </details>
  );
}
